/*global google*/


import React, { useContext, useState, useEffect, useRef } from 'react';
import { Button, Form, InputGroup, Col, Row, Container, Modal, ProgressBar } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp, faCartShopping, faArrowLeft, faBagShopping, faCalendar} from '@fortawesome/free-solid-svg-icons';
import { getItemAttributeNameById } from '../functions';
import EditCartModal from '../elements/EditCartModal';
import { checkCouponThunk, clearCoupon } from '../store/coupons';
import { useDispatch, useSelector } from 'react-redux';
import EditFreeItemModal from '../elements/EditFreeItemModal';
import { getFreeItemsThunk } from '../store/freeitems';
import { placeOrderThunkPayInStore } from '../store/order';
import { useNavigate } from 'react-router-dom';
import CheckoutApp from '../elements/StripeCheckoutApp';
import loadingJson from '../asset/JSON/loading.json'
import Lottie from 'react-lottie-player';
import  Context  from '../Context';
import {  isStoreOpen, showTimeError } from '../Context/helper';
import Swal from 'sweetalert2';
import { buyPointsThunk, getRewardsThunk } from '../store/rewards';
import { RewardModal } from '../elements/RewardModal';
import EditRewardItemModal from '../elements/EditRewardItemModal';
import { getHoursThunk, getRestaurantThunk } from '../store/restaurant';
import MapboxDeliveryInput from '../elements/MapboxAutofill';
import MapboxIsochroneMap from '../elements/MapboxPreview';
import GooglePlacesDeliveryInput from '../elements/MapboxAutofill';
import AddressModal from '../elements/MapboxAutofill';



const CheckoutPage = ({ fee }) => {
  const navigate = useNavigate();
  const { language, restaurantId, changedCart, setChangedCart} = useContext(Context);
  const [promoCode, setPromoCode] = useState('');
  const cart = JSON.parse(localStorage.getItem('cart')) || [];
  const freeItem = JSON.parse(localStorage.getItem(`freeItem`)) || [];
  const rewardItem = JSON.parse(localStorage.getItem(`rewardItem`)) || [];
  const [orderMethod, setOrderMethod] = useState('pickup'); // pickup or delivery
  const [cartOpen, setCartOpen] = useState(true); // State to toggle cart items
  const [editCartModal, setEditCartModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [currentUserAddress, setCurrentUserAddress] = useState(null);
  const [addressVerified, setAddressVerified] = useState(false);
  const [addressErrors, setAddressErrors] = useState('');
  const [needDelivery, setNeedDelivery] = useState(false);
  const [checkingCoupon, setCheckingCoupon] = useState(false);
  const [couponError, setCouponError] = useState('');
  const [tip, setTip] = useState(10);
  const [customTip, setCustomTip] = useState(0);
  const [showTipModal, setShowTipModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false); // State for payment modal
  const dispatch = useDispatch();
  const checkCoupon = useSelector(state => state.coupons.coupon);
  const [editFreeItem, setEditFreeItem] = useState(false);
  const freeItems = useSelector((state) => state.freeItems.freeitems);
  const [paymentOption, setPaymentOption] = useState('online');
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const [activeTab, setActiveTab] = useState(false);
  const [payinStoreLoading, setPayinStoreLoading] = useState(false);  // State for loading spinner
  const [paymentSubmitLoading, setPaymentSubmitLoading] = useState(false);  // State for loading spinner
  const [needSchdule, setNeedSchdule] = useState(false)
  const [timeSlots, setTimeSlots] = useState([]);
  const [selectedTime, setSelectedTime] = useState(null);
  const [timeModal, setTimeModal] = useState(false)
  const [rewardPoints, setRewardPoints] = useState(0);
  const [loading, setLoading] = useState(false);
  const [isRewardModalOpen, setIsRewardModalOpen] = useState(false);
  const [editRewardItem, setEditRewardItem] = useState(false);
  const hours = useSelector((state) => state.restaurants?.hours);

const [showAddressModal, setShowAddressModal] = useState(false);
const [savedAddresses, setSavedAddresses] = useState([]); // Populate this from your backend
 const [distanceText, setDistanceText] = useState('');
  const [addressInput, setAddressInput] = useState('');

  useEffect(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, []);
  useEffect(() => {
    const generateTimeSlots = () => {
      const slots = [];
      const currentDate = new Date();
      currentDate.setSeconds(0, 0); // Reset seconds and milliseconds
      
      let startTime = new Date();
      let endTime = new Date();
      
      // Set the start time to 11:00 AM and end time to 8:30 PM
      startTime.setHours(11, 0, 0, 0);  // 11:00 AM
      endTime.setHours(20, 30, 0, 0);  // 8:30 PM
      
      // Rounding the start time to the next 5-minute mark
      const minutes = startTime.getMinutes();
      const roundedMinutes = Math.ceil(minutes / 5) * 5;
      startTime.setMinutes(roundedMinutes);
      
      // Generating 5-minute interval slots from the start time to the end time
      while (startTime <= endTime) {
        if (startTime > currentDate) { // Check if the start time is after the current time
          const formattedDate = startTime.toLocaleString('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true,
          });
          slots.push(formattedDate);
        }
        startTime.setMinutes(startTime.getMinutes() + 5); // Increase by 5 minutes
      }
    
      setTimeSlots(slots);
    };
  
    generateTimeSlots();
  }, []);


  const handleTimeSelect = (time) => {
    setSelectedTime(time);
  };


  useEffect(() => { 
      if(!showPaymentModal){
        setName('');
        setPhone('');
        setError('');
        setActiveTab(false);
      }
  },[showPaymentModal])



  useEffect(() => { 
    if (restaurantId) {
      dispatch(getFreeItemsThunk(restaurantId));
      dispatch(getHoursThunk(restaurantId))
      dispatch(getRestaurantThunk(restaurantId))
    }
  },[restaurantId, dispatch]);


  

  //handle coupon
  const checkCurrentCoupon = async (e) => {
    e.preventDefault();
    setCheckingCoupon(true);
    setCouponError('');
    try { 
       await dispatch(checkCouponThunk(promoCode));
    } catch (error) {
      setCheckingCoupon(false);
    } finally {
      setCheckingCoupon(false);
    }
  };

  const handleRemoveCoupon = () => {
    setPromoCode('');
    setCouponError('');
    dispatch(clearCoupon(''));
  };

  const handleEditCartModal = (item) => {
    setSelectedItem(item);
    setEditCartModal(true);
  };

  const calculateSubtotal = () => {
    let subtotal = cart.reduce(
      (total, cartItem) => total + cartItem.Item.price * cartItem.quantity,
      0
    );  

    cart.forEach((cartItem) => {
      cartItem.options.forEach((option) => {
        subtotal += option.priceModifier * cartItem.quantity;
      });
    });

    return subtotal.toFixed(2);


  };

  const calculateTaxes = () => {
    return (calculateSubtotal() * fee?.tax).toFixed(2);
  };

  const calculateDiscount = () => {
    const subtotal = parseFloat(calculateSubtotal());
    let discount = 0;

    if (checkCoupon && subtotal >= parseFloat(checkCoupon.min_require)) {
      if (checkCoupon.discount_type === 'Percentage') {
        discount = (subtotal * (parseFloat(checkCoupon.discount) / 100)).toFixed(2);
      } else {
        discount = parseFloat(checkCoupon.discount);
      }
    }

    return discount;
  };

  const calculateServiceFee = () => {
    const subtotal = parseFloat(calculateSubtotal());
    return (subtotal * fee?.service_fee + parseFloat(fee?.commission_fee))?.toFixed(2);
  };

  const calculateTip = () => {
    const subtotal = parseFloat(calculateSubtotal());
    return ((subtotal * tip) / 100).toFixed(2);
  };

  const calculateTotal = () => {
    const subtotal = parseFloat(calculateSubtotal());
    const taxes = parseFloat(calculateTaxes());
    const discount = calculateDiscount();
    const commissionFee = parseFloat(fee?.commission_fee);
    const serviceFee = orderMethod === 'delivery' ? parseFloat(calculateServiceFee()) : 0;
    const deliveryFee = orderMethod === 'delivery' ? parseFloat(fee?.delivery_fee) : 0;
    const tipAmount = parseFloat(customTip || calculateTip());

    let total = (subtotal + taxes - discount + serviceFee + deliveryFee + tipAmount).toFixed(2);
    if (orderMethod === 'pickup') {
      total = (parseFloat(total) + commissionFee).toFixed(2);
    }
    return total;
  };

  useEffect(() => { 
    if(checkCoupon?.min_require && parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require)){
      setCouponError('Minimum order amount of $' + checkCoupon.min_require + ' is required to use this coupon.');
    }
  },[checkCoupon, calculateSubtotal()])

  const handleTipSelect =  (percentage) => {
    setTip(percentage)
    setCustomTip(0)
 };

 const handleCustomTip = () => {
  setTip(0);
   setShowTipModal(true);
 };

 const incrementTip = () => setCustomTip(prevTip => +prevTip + 1);
 const decrementTip = () => setCustomTip(prevTip => +Math.max(0, prevTip - 1));


 const handleCustomTipChange = (e) => {
   if (/^\d*$/.test(e.target.value)) { // Allow only digits
     setCustomTip(Number(e.target.value));
   }
   setTip(0); // Reset tip percentage
 };


  const handleEditFreeItem = (item) => {
    setSelectedItem(item);
    setEditFreeItem(true);
  };

  const handleEditRewardItem = (item) => {
    setSelectedItem(item);
    setEditRewardItem(true);
  };

    function toTitleCase(str) {
    return str
      ?.split(" ")
      ?.map(word => {
        // Capitalize first letter only if it's alphabetic
        if (/^[a-z]/i?.test(word)) {
          return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
        }
        return word;
      })
      ?.join(" ");
  }

  const restaurantAddress = `${toTitleCase('1880 Braselton Hwy, Suite 122,')}, ${toTitleCase('Lawrenceville GA 30043, USA')}`;

let scriptLoaded = false;

function loadGoogleMapsScript() {
  return new Promise((resolve, reject) => {
    if (scriptLoaded && window.google) {
      resolve(window.google);
      return;
    }

    const script = document.createElement("script");
    script.src =
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyBVBmPNmWThlFAv8lyHtESSsZIQLHiDl30&libraries=places";
    script.async = true;
    script.defer = true;

    script.onload = () => {
      scriptLoaded = true;
      resolve(window.google);
    };

    script.onerror = (e) => reject(e);

    document.head.appendChild(script);
  });
}
// Usage in your component
useEffect(() => {
  if (!showAddressModal) return;

  loadGoogleMapsScript()
    .then(() => {
      handleScriptLoad()
    })
    .catch((error) => {
      console.error("Google Maps API failed to load", error);
    });
}, [showAddressModal]);
  
  let autocomplete;
    const handleScriptLoad = () => {
      autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        { types: ["geocode"] }
      );
      autocomplete.addListener("place_changed", handlePlaceSelect);
    };
  async function handlePlaceSelect() {
  let place = autocomplete.getPlace();

  if (!place.geometry) {
    setAddressErrors("Please enter a valid address");
    // Clear input to force user reselect or type a valid address
    setAddressInput("");
    return;
  }

  const isWithinDistance = await checkDistance(place.formatted_address);

  if (isWithinDistance) {
    setCurrentUserAddress(place.formatted_address);
    setAddressInput(place.formatted_address);
    setAddressVerified(true);
    setAddressErrors("");
  } else {
    // Show error message but DO NOT reset input value!
    setAddressErrors(`Sorry, we can only deliver up to 6 miles.`);
    setCurrentUserAddress(place.formatted_address);
    setAddressInput(place.formatted_address);
    setAddressVerified(false);
    // Important: Do NOT update setAddressInput here, so full address stays visible
  }
}


const checkDistance = async (userAddress) => {
  const service = new google.maps.DistanceMatrixService();
  return new Promise((resolve) => {
    service.getDistanceMatrix(
      {
        origins: [userAddress],
        destinations: [restaurantAddress],
        travelMode: google.maps.TravelMode.DRIVING,
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      (response, status) => {
        if (status === 'OK') {
          const element = response.rows[0].elements[0];

          if (element.status === 'OK') {
            const distanceInMiles = element.distance.value * 0.000621371;

            setDistanceText(Number(distanceInMiles).toFixed(2));

            if (distanceInMiles <= (6)) {
              setAddressErrors("");
              setAddressVerified(true);
              resolve(true);
            } else {
              setAddressErrors(
                `Sorry, we cannot deliver to places more than ${(6)} miles away.`
              );
              setAddressVerified(false);
              resolve(false);
            }
          } else {
            setAddressErrors("Unable to calculate driving distance. Please try again later.");
            setAddressVerified(false);
            setDistanceText(null);
            resolve(false);
          }
        } else {
          setAddressErrors("Error retrieving distance matrix. Please try again later.");
          setAddressVerified(false);
          setDistanceText(null);
          resolve(false);
        }
      }
    );
  });
};


  
  
  const needAmountReached = () => {
    // Iterate through freeItems array
    const freeItemed = JSON.parse(localStorage.getItem('freeItem'));

    if(freeItemed?.Item){
    for (const freeItem of freeItems) {
      // Find the matching ReedemableItem based on item 
      for(const item of freeItem.ReedemableItems){ 
        if(item?.Item?.id === freeItemed?.Item?.id){
          return +freeItem.need_amount <= +calculateSubtotal();
        }
      }
    }} else { 
      return true;
    }
  };

  const isRestaurantOpen = () => {
    if (!hours?.time_zone) return false;
    
    const timeZoneMap = {
      "EST": "America/New_York",
      "CST": "America/Chicago",
      "MST": "America/Denver",
      "PST": "America/Los_Angeles",
    };
  
    const timeZone = timeZoneMap[hours.time_zone] || "America/New_York";
    const now = new Date();
  
    const currentDay = now.toLocaleString("en-US", { timeZone, weekday: "long" }).toLowerCase();
    const todayHours = hours[currentDay];
  
    if (!todayHours || todayHours.toLowerCase() === "closed") return false;
  
    const [openClose, breakTime] = todayHours.split("|");
    const [openStr, closeStr] = openClose.split("-");
    const [breakStartStr, breakEndStr] = breakTime?.split("-") || [];
  
    const getMinutes = (timeStr) => {
      const [h, m] = timeStr.split(":").map(Number);
      return h * 60 + m;
    };
  
    const currentTime = now.toLocaleTimeString("en-US", {
      timeZone,
      hour12: false,
      hour: "2-digit",
      minute: "2-digit"
    });
  
    const nowMinutes = getMinutes(currentTime);
    const openMinutes = getMinutes(openStr);
    const closeMinutes = getMinutes(closeStr);
    if (nowMinutes < openMinutes || nowMinutes > closeMinutes) return false;
  
    if (breakStartStr && breakEndStr) {
      const breakStartMinutes = getMinutes(breakStartStr);
      const breakEndMinutes = getMinutes(breakEndStr);
      if (nowMinutes >= breakStartMinutes && nowMinutes < breakEndMinutes) return false;
    }
  
    return true;
  };
  const showRestaurantTimeError = () => {
    const timeZone = hours?.time_zone || "EST";
    const days = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
  
    const formattedHours = days.map(day => {
      const key = day.toLowerCase();
      const raw = hours?.[key];
  
      if (!raw || raw.toLowerCase() === "closed") return `${day}: Closed`;
  
      const [main, breakStr] = raw.split("|");
      const display = `${main}${breakStr ? ` (Break: ${breakStr})` : ""}`;
      return `${day}: ${display}`;
    }).join("\n");
  
    Swal.fire({
      icon: 'error',
      title: 'Please come back later.',
      html: `<pre style="text-align:left">${formattedHours}</pre><br/><b>Time Zone:</b> ${timeZone}`
    });
  };
  const handlePlaceOrder = () => {
    if (!isRestaurantOpen()) { 
      showRestaurantTimeError();
      return;
    }
  
    const lunchitem = cart.filter(item => item.Item.name.toLowerCase().includes('lunch'));
  
    if (lunchitem.length > 0) {
      const now = new Date();
      const estNow = new Date(
        now.toLocaleString('en-US', { timeZone: 'America/New_York' })
      );
      const hour = estNow.getHours();
      const minutes = estNow.getMinutes();
    
      // Lunch not available after 4:00 PM
      if (hour > 16 || (hour === 16 && minutes > 0)) {
        Swal.fire({
          title: 'Lunch Not Available',
          text: 'Lunch items are only available from opening time until 4:00 PM EST. Please remove it from your cart to continue. Thank you!',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
        return;
      }
    }
    
  
    if (!name || !phone) {
      setError('Please enter your name and phone number.');
      return;
    }
  
    // Only allow numbers for phone, and length of 10
    if (!/^\d{10}$/.test(phone)) {
      setError('Please enter a valid phone number. Only numbers are allowed.');
      return;
    }
  
    setShowPaymentModal(true);
  };
  

  const handlePaymentMethodChange = (selectedOption) => {
    setPaymentOption(selectedOption);
  }



  const handlePayInStore = async () => {
    setPayinStoreLoading(true);
    try {
      await dispatch(placeOrderThunkPayInStore(
        restaurantId,
        paymentOption,
        name,
        phone,
        customTip || calculateTip(),
        currentUserAddress || null,
        cart,
        calculateDiscount() > 0 ? checkCoupon?.coupon_id : null,
        freeItem?.Item ? freeItem : null,
        null, 
        selectedTime ? selectedTime : 'ASAP',
        rewardItem?.Item ? rewardItem : null,
      ))
      .then(() => {
      
         dispatch(buyPointsThunk(restaurantId, phone, name, calculateSubtotal()));

      setChangedCart(!changedCart);
      setPayinStoreLoading(false);
      
      navigate('/orderconfirmed');
      })
    } catch (error) {
      setPayinStoreLoading(false);
      console.error('An error occurred:', error);
      setError('An error occurred. Please try again later.');
    }
  }
  
  const handleSchduleTimeClick = () => { 
    setNeedSchdule(true)

    setTimeModal(true)
  }

// Function to handle raw phone value and store it
const handlePhoneChange = (e) => {
  const input = e.target.value.replace(/\D/g, ''); // Remove non-digit characters
  if (input.length <= 10) {
    setPhone(input); // Store only raw 10-digit phone number
  }

  // Automatically trigger reward points check if input is exactly 10 digits
  if (input.length === 10) {
    checkRewardPoints(input);
  }
};

// Function to format phone number for display
const formatPhoneNumber = (phone) => {
  if (phone.length > 6) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3, 6)}-${phone.slice(6)}`;
  } else if (phone.length > 3) {
    return `(${phone.slice(0, 3)}) ${phone.slice(3)}`;
  } else if (phone.length > 0) {
    return `(${phone}`;
  }
  return '';
};

const checkRewardPoints = async (phoneNumber) => {
  setLoading(true);
  try {
    const points = await dispatch(getRewardsThunk(restaurantId, phoneNumber));
    if(points){
      setRewardPoints(points);
    }else {
      setRewardPoints(0);
    }
  } catch (error) {
    console.error('Error fetching reward points:', error);
  } finally {
    setLoading(false);
  }
};
const handleSelectSavedAddress = (addr) => {
  setAddressInput(addr);
  setCurrentUserAddress(addr);
  checkDistance(addr)
};
const handleSaveAddress = () => {
  setAddressVerified(true);


  const key = `savedAddresses_${restaurantId}`;
  // Get existing saved addresses from localStorage or start with empty array
  const saved = localStorage.getItem(key);
  const savedAddresses = saved ? JSON.parse(saved) : [];

  // Add new address only if it doesn't already exist
  if (!savedAddresses.includes(addressInput)) {
    savedAddresses.unshift(addressInput);
    // Keep only the 5 most recent addresses
    localStorage.setItem(key, JSON.stringify(savedAddresses.slice(0, 3)));
  }

  // Close the modal after saving
  setShowAddressModal(false);
};
  return (
    <>
    {/* <Header /> */}
    <Container className="checkout-page" style={{marginTop:'135px'}}> 
      <Row>
  <Col md={7}>
    {/* Back Navigation */}
    <div 
      className="d-flex align-items-center mb-4 cursor-pointer text-danger" 
      onClick={() => navigate('/order')}
    >
      <i className="fas fa-arrow-left me-2 fs-5"></i>
      <h5 className="mb-0 fw-semibold">Continue Shopping</h5>
    </div>

    {/* Checkout Section */}
    <div className="card border-0 shadow-sm p-4 mb-4">
      <div className="d-flex flex-column gap-4">
        {/* Order Method Selection */}
        <div>
          <div className="d-grid gap-2">
            <Button
              variant={orderMethod === 'pickup' ? 'primary' : 'outline-dark'}
              size="lg"
              className={`rounded-pill ${orderMethod === 'pickup' ? 'fw-bold' : ''}`}
              onClick={() => {
                setOrderMethod('pickup');
                setNeedDelivery(false);
                setCurrentUserAddress(null);
                setAddressVerified(false);
              }}
            >
              <i className="fas fa-store me-2"></i>
              Pickup

            </Button>
            <Button
              variant={orderMethod === 'delivery' ? 'primary' : 'outline-dark'}
              size="lg"
              className={`rounded-pill ${orderMethod === 'delivery' ? 'fw-bold' : ''}`}
              onClick={() => {
                setOrderMethod('delivery');
                setNeedDelivery(true);
              }}
            >
              <i className="fas fa-truck me-2"></i>
              Delivery
            </Button>
          </div>
        </div>
        {/* Delivery Details */}
{orderMethod === 'delivery' && (
  <div className=" rounded-3 text-start">
    <h5 className="fw-bold mb-3" style={{ color: '#e30613', fontSize: '1.1rem' }}>Delivery Address</h5>
    
    {/* Address Display */}
    <div 
      className="d-flex align-items-center justify-content-between p-3 border-0 rounded-3"
      style={{ 
        cursor: 'pointer',
        backgroundColor: '#fff0f0',
        border: '1px solid #ffcccc',
        transition: 'all 0.2s ease',
        height: '70px'
      }}
      onClick={() => setShowAddressModal(true)}
    >
      <div className="d-flex align-items-center">
        <div 
          className="d-flex align-items-center justify-content-center p-2 rounded-circle me-3"
          style={{
            backgroundColor: '#e30613',
            width: '40px',
            height: '40px'
          }}
        >
          <i className="fas fa-map-marker-alt text-white" style={{ fontSize: '1rem' }}></i>
        </div>
        <div>
          {currentUserAddress ? (
            <>
              <p className="mb-0 fw-semibold" style={{ color: '#333', fontSize: '0.95rem' }}>
                {currentUserAddress}
              </p>
            </>
          ) : (
            <p className="mb-0 fw-semibold" style={{ color: '#e30613', fontSize: '0.95rem' }}>
              Add delivery address
            </p>
          )}
        </div>
      </div>
      <i className="fas fa-chevron-right" style={{ color: '#e30613' }}></i>
    </div>

          <AddressModal
  showAddressModal={showAddressModal}
  setShowAddressModal={setShowAddressModal}
  onSaveAddress={handleSaveAddress}
  addressInput={addressInput}
  setAddressInput={setAddressInput}
  addressVerified={addressVerified}
  addressErrors={addressErrors}
  distanceText={distanceText}
  restaurantId={restaurantId}
  handleSelectSavedAddress={handleSelectSavedAddress}
/>

  </div>
)}

<div className="border-top my-1" style={{ borderTopWidth: '0.5px' }}></div>        {/* Schedule Options */}
       <div className="border-0 bg-white rounded-3 p-3" style={{ border: '1px solid #ffebee' }}>
  <h5 className="fw-bold mb-3 text-start" style={{ color: '#e30613', fontSize: '1.1rem' }}>
    {needDelivery ? 'Delivery' : 'Pickup'} Options
  </h5>
  
  <div 
    className={`d-flex align-items-center p-2 rounded-3 ${!needSchdule ? 'bg-red-soft' : 'bg-white'}`}
    style={{ 
      cursor: 'pointer',
      border: `1px solid ${!needSchdule ? '#e30613' : '#ffebee'}`,
      transition: 'all 0.2s ease'
    }}
    onClick={() => {
      setNeedSchdule(false);
      setSelectedTime(null);
    }}
  >

    
    <div className="flex-grow-1">
      <p 
        className="mb-0 fw-semibold" 
        style={{ 
          color: !needSchdule ? '#e30613' : '#333',
          fontSize: '0.95rem'
        }}
      >
        {needDelivery  ? 'Standard 30-45 min' : 'Standard 15-30 min'}
      </p>
  
    </div>
    
    {!needSchdule && (
      <i 
        className="fas fa-check-circle text-danger ms-2" 
        style={{ fontSize: '1.2rem' }}
      ></i>
    )}
  </div>
</div>
      </div>
    </div>

    {/* Location Info */}
    {/* <div className="text-center text-muted small">
      <i className="fas fa-map-marker-alt me-2"></i>
      1880 Braselton Hwy #122, Lawrenceville, GA 30043
    </div> */}
  </Col>
        <Col md={5}>
          <div className="section cart-summary">
            <h5 className="cart-summary-header" onClick={() => setCartOpen(!cartOpen)}>
              <FontAwesomeIcon icon={faCartShopping} className="toggle-icon" />
              Cart summary ({cart.length} item{cart.length !== 1 ? 's' : ''})
              <FontAwesomeIcon icon={cartOpen ? faChevronUp : faChevronDown} className="toggle-icon" />
            </h5>

            {+cart.length > 0 && (
                      <button className="btn btn-primary w-100 " onClick={() => { 
                        localStorage.removeItem('cart');
                        localStorage.removeItem('freeItem');
                        setChangedCart(!changedCart);
                      }}>
                        Clear Cart
                      </button>

              )}

            {cartOpen && (
              <>
              
      


              <div>

                {rewardItem?.Item && (
                    <div
                      onClick={() => handleEditRewardItem({
                        id: rewardItem?.Item.id,
                        name: rewardItem?.Item?.name,
                        price: rewardItem?.Item.price,
                        quantity: rewardItem?.quantity,
                        special_instructions: rewardItem?.special_instructions,
                        image_url: rewardItem?.Item?.image_url,
                        Restaurant_Item_Attributes: rewardItem?.Item?.Restaurant_Item_Attributes,
                        options: rewardItem?.options,
                      })}
                      className="cart-item d-flex align-items-start mb-3"
                    >
                          <img
                      src={rewardItem.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'}
                      alt={rewardItem.Item.name}
                      className="cart-item-image me-3"
                    />
                    <div className="cart-item-details flex-grow-1">
                    <p className='item-name mb-1'>{language === 'en' ? rewardItem?.Item?.name : rewardItem?.Item?.chinese_name}</p>
                            {rewardItem?.options?.map((attribute) => (
                              <p className="item-attribute small m-0" key={attribute.id}>
                                {getItemAttributeNameById(attribute.id, rewardItem.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                              </p>
                            ))}
                            {rewardItem?.special_instructions && (
                              <p className="item-instructions small m-0">
                                <strong>**</strong> {rewardItem?.special_instructions}
                              </p>
                            )}
                          </div>
                          <div className="cart-item-quantity d-flex align-items-center justify-content-center">
                            <span className="item-quantity">1</span>
                            </div>
                            <p className="item-price ms-3">Reward</p>

                    </div>

                  )
                      }

              {freeItem?.Item && (
                    <div
                      onClick={() => handleEditFreeItem({
                        id: freeItem?.Item.id,
                        name: freeItem?.Item?.name,
                        price: freeItem?.Item.price,
                        quantity: freeItem?.quantity,
                        special_instructions: freeItem?.special_instructions,
                        image_url: freeItem?.Item?.image_url,
                        Restaurant_Item_Attributes: freeItem?.Item?.Restaurant_Item_Attributes,
                        options: freeItem?.options,
                      })}
                      className="cart-item d-flex align-items-start mb-3"
                    >
                          <img 
                      src={freeItem.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'} 
                      alt={freeItem.Item.name} 
                      className="cart-item-image me-3" 
                    />
                    <div className="cart-item-details flex-grow-1">
                    <p className='item-name mb-1'>{language === 'en' ? freeItem?.Item?.name : freeItem?.Item?.chinese_name}</p>
                            {freeItem?.options?.map((attribute) => (
                              <p className="item-attribute small m-0" key={attribute.id}>
                                {getItemAttributeNameById(attribute.id, freeItem.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                              </p>
                            ))}
                            {freeItem?.special_instructions && (
                              <p className="item-instructions small m-0">
                                <strong>**</strong> {freeItem?.special_instructions}
                              </p>
                            )}
                          </div>
                          <div className="cart-item-quantity d-flex align-items-center justify-content-center">
                            <span className="item-quantity">1</span>
                            </div>
                            <p className="item-price ms-3">Free</p>
                            

                    </div>
                    
                  )  
                  }
              </div>

              <div>
                {cart.map((item, index) => (
                  <div key={index} className="cart-item d-flex align-items-start mb-3"
                    onClick={() => handleEditCartModal({
                      id: item?.Item.id,
                      name: item?.Item?.name,
                      price: item?.Item.price,
                      special_instructions: item?.special_instructions,
                      image_url: item?.Item?.image_url,
                      Restaurant_Item_Attributes: item?.Item?.Restaurant_Item_Attributes,
                      options: item?.options,
                      index: index,
                    })}
                  >
                    <img 
                      src={item.Item.image_url || 'https://theme-assets.getbento.com/sensei/3914814.sensei/assets/images/catering-item-placeholder-704x520.png'} 
                      alt={item.Item.name} 
                      className="cart-item-image me-3" 
                    />
                    <div className="cart-item-details flex-grow-1">
                      <p className="item-name mb-1">{language === 'en' ? item?.Item?.name : item?.Item?.chinese_name}</p>
                      {item?.options?.map((attribute, idx) => (
                        <p className="item-attribute small m-0" key={idx}>
                          {getItemAttributeNameById(attribute.id, item.Item)} {attribute?.priceModifier > 0 ? `+ $${attribute.priceModifier}` : null}
                        </p>
                      ))}
                      {item?.special_instructions && (
                        <p className="item-instructions small m-0">
                          <strong>**</strong> {item?.special_instructions}
                        </p>
                      )}
                    </div>
                    <div className="cart-item-quantity d-flex align-items-center justify-content-center">
                      <span className="item-quantity">{item.quantity}</span>
                    </div>
                    <p className="item-price ms-3">${item.price}</p>
                  </div>
                ))}
              </div>
              </>
            )}
          </div>
          <div className="section promotion">
            <h5>Promotion</h5>
            <InputGroup>
              <Form.Control
                type="text"
                placeholder="Add promo code"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
              />
              <Button variant="outline-primary" onClick={(e) => checkCurrentCoupon(e)}>
                {checkingCoupon ? <span className="spinner-border spinner-border-sm"></span> : 'Apply'}
              </Button>
            </InputGroup>
            {checkCoupon && parseFloat(calculateSubtotal()) >= parseFloat(checkCoupon.min_require) && (
              <div className="mt-2">
                <p className="text-success">Coupon applied! Discount: ${calculateDiscount()}</p>
                <Button variant="link" onClick={handleRemoveCoupon}>Remove coupon</Button>
              </div>
            )}
            {checkCoupon && parseFloat(calculateSubtotal()) < parseFloat(checkCoupon.min_require) && (
              <div className="mt-2">
                <p className="text-danger">Minimum order amount of ${checkCoupon.min_require} is required to use this coupon.</p>
              </div>
            )}
            {checkCoupon && checkCoupon.message && (
              <div className="mt-2">
                <p className="text-danger">{checkCoupon.message}</p>
              </div>
            )}
            {!checkCoupon && (
              <div className="mt-2">
                <p className="text-danger">{couponError || 'Invalid coupon code.'}</p>
              </div>
            )}
          </div>

          <div className="section customer-detail">
  <h5 style={{ fontSize: '1.2rem', marginBottom: '1rem' }}>Customer Info*</h5>

  <div className="row">
  {/* Name Input */}
  <div className="col-12 col-md-6 mb-3">
    <input
      type="text"
      className="form-control"
      id="name"
      value={name}
      onChange={(e) => setName(e.target.value)}
      placeholder="Name"
      required
      maxLength={20}
    />
  </div>

  {/* Phone Number Input with Display Formatting */}
  <div className="col-12 col-md-6 mb-3">
    <input
      type="tel"
      className="form-control"
      id="phone"
      value={formatPhoneNumber(phone)} // Display formatted value
      onChange={handlePhoneChange} // Update raw phone value
      placeholder="(123) 456-7890"
      required
      maxLength={14} // To account for display formatting
    />
  </div>


</div>
</div>

<div className="section tip-options">
<div className='row'>
  <div className="col-12">
      {/* Loading Spinner */}
  {loading && (
    <div className="col-12 mb-3 text-center">
      <div className="spinner-border text-primary" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
    </div>
  )}

      <RewardModal
        isOpen={isRewardModalOpen}
        onClose={() => setIsRewardModalOpen(false)}
        points={rewardPoints}
        phone={phone}
        handlePhoneChange={handlePhoneChange}
      />
    </div>

</div>
<div className='row'>
  <div className="col-12">
  {!loading && (
      <div className="col-12 ">
        {phone.length !== 10 ? (
          <div className="alert alert-warning">
            Please enter a 10 digit phone number above to see your points.
          </div>
        ) : phone.length === 10 && !rewardPoints ? (
          <div className="alert alert-warning">
            You dont have any reward points, Start ordering with this number to earn reward points to this number.
          </div>
        ) : (
          <div className="alert alert-success">
            You have <strong>{rewardPoints}</strong> reward points!
          </div>
        )}
      </div>
    )}
  </div>
  <button
        className="btn btn-primary mt-3 w-100"
        onClick={() => setIsRewardModalOpen(true)}
      >
        See All Available Rewards
      </button>
</div>

</div>




        
          <div className="section order-total">
            <h5>Order total</h5>
            <div className="order-summary">
              <p>Subtotal <span>${calculateSubtotal()}</span></p>
              <p>Taxes <span>${calculateTaxes()}</span></p>
              {orderMethod === 'pickup' && (
              <p>Commission Fee <span>${parseFloat(fee?.commission_fee).toFixed(2)}</span></p>
              )}
              {checkCoupon && parseFloat(calculateSubtotal()) >= parseFloat(checkCoupon.min_require) && (
                <p>Discount <span>-${calculateDiscount()}</span></p>
              )}
              {orderMethod === 'delivery' && (
                <>
                  <p>Service Fee <span>${calculateServiceFee()}</span></p>
                  <p>Delivery Fee <span>${fee?.delivery_fee}</span></p>
                </>
              )}
              <p>Tip <span>${parseFloat(customTip || calculateTip()).toFixed(2)}</span></p>
              <div className="tip-options-container">
                  <Button 
                    variant={tip === 10 ? "primary" : "outline-primary"} 
                    className={`tip-option custom-button ${tip === 10 ? 'active' : ''}`} 
                    onClick={() => handleTipSelect(10)}
                  >
                    10%
                  </Button>
                  <Button 
                    variant={tip === 15 ? "primary" : "outline-primary"} 
                    className={`tip-option custom-button ${tip === 15 ? 'active' : ''}`} 
                    onClick={() => handleTipSelect(15)}
                  >
                    15%
                  </Button>
                  <Button 
                    variant={tip === 18 ? "primary" : "outline-primary"} 
                    className={`tip-option custom-button ${tip === 18 ? 'active' : ''}`} 
                    onClick={() => handleTipSelect(18)}
                  >
                    18%
                  </Button>
                  <Button 
                    variant="outline-primary" 
                    className="tip-option " 
                    onClick={handleCustomTip}
                  >
                    Custom
                  </Button>
                </div>
              <p>Total <span>${calculateTotal()}</span></p>
            </div>
          </div>
          {calculateSubtotal() > 0 && (
            <p class="text-primary fw-bold text-center mt-2">
    You Will Earn {(calculateSubtotal() * 10).toFixed(2)} reward points this order
</p>
          )
          }
            <p className="text-danger">{!needAmountReached() && 'You need to reach the minimum amount to redeem the free item.'}</p>
            {orderMethod === 'delivery' && calculateSubtotal() < 15 && <p className="text-danger">Minimum order amount of $15 in subtotal is required for delivery.</p>}
            {orderMethod === 'delivery' && !addressVerified && <p className="text-danger">Please enter a valid address within 6 miles of the restaurant.</p>}
            {isStoreOpen() === false && <p className="text-danger">Sorry, we are currently closed. Refer to our store hours.</p>}
            {error && <p className="text-danger">{error}</p>}
            <p className="text-muted text-center">
  {(() => {
    const now = new Date();
    const day = now.toLocaleDateString("en-US", { weekday: "long" }).toLowerCase();
    const date = now.toLocaleDateString("en-US", { month: "numeric", day: "numeric" });
    const time = now.toLocaleTimeString("en-US", { hour: "numeric", minute: "2-digit", hour12: true });
    const info = hours?.[day];
    if (!info || info.toLowerCase() === "closed") return `Today ${date}, ${time} — Closed`;
    const [main, br] = info.split("|");
    const [o, c] = main.split("-");
    return `${date}: Open ${o}–${c}${br ? ` | Break ${br}` : ""}`;
  })()}
</p>

          <button className="btn-primary w-100 p-4 "
          style={{fontSize: '20px'}}
          disabled={
            orderMethod === 'delivery' && !addressVerified
            || !needAmountReached()
            || orderMethod === 'delivery' && calculateSubtotal() < 20
            // || isStoreOpen() === false
           
          }
          
          onClick={handlePlaceOrder}
          >Place Order</button>
        </Col>
      </Row>
      <EditCartModal modal={editCartModal} item={selectedItem} setModal={setEditCartModal} />
      <EditFreeItemModal  modal={editFreeItem} item={selectedItem} setModal={setEditFreeItem} />
      <EditRewardItemModal  modal={editRewardItem} item={selectedItem} setModal={setEditRewardItem} />
      <Modal show={showTipModal} onHide={() => setShowTipModal(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enter Custom Tip</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group className="d-flex align-items-center justify-content-center">
          <button className="btn btn-outline-primary" onClick={decrementTip}>
            <FontAwesomeIcon icon={faChevronDown} />
          </button>
          <Form.Control
            type="tel"
            min="0"
            value={customTip}
            onChange={handleCustomTipChange}
            placeholder="Enter custom tip amount"
            className="mx-2 text-center"
            style={{ maxWidth: '100px' }}
          />
          <button className="btn btn-outline-primary" onClick={incrementTip}>
            <FontAwesomeIcon icon={faChevronUp} />
          </button>
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <button className="w-100 btn btn-primary" onClick={() => setShowTipModal(false)}>Save</button>
      </Modal.Footer>
    </Modal>
      <Modal show={showPaymentModal} onHide={() => setShowPaymentModal(false)} backdropClassName="overlay" centered size="lg">

        
        <>
          <Modal.Header closeButton>
            <Modal.Title>Payment Method</Modal.Title>
          </Modal.Header>
          <Modal.Body>
  {paymentSubmitLoading ? (
    <Lottie 
      loop
      animationData={loadingJson}
      play
    />
  ) : (
    <>
      <div className="d-flex">
        {needDelivery ? (
         <Button
         variant='primary'
         className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : 'outline-primary'}`}
           onClick={() => handlePaymentMethodChange('online')}
         >
           Online
         </Button>
        ) : (
          <div className='d-flex align-items-center justify-content-center w-100'>
                       <button

         className={`payment-button w-100 ${paymentOption === 'online' ? 'primary' : 'outline-primary'}`}
         onClick={() => handlePaymentMethodChange('online')}
            >
              Online
            </button>
            <button

         className={`payment-button w-100 ${paymentOption === 'in-store' ? 'primary' : 'outline-primary'}`}
         onClick={() => handlePaymentMethodChange('in-store')}
            >
              Instore
            </button>
            
          </div>
        )}
      </div>
      {paymentOption === 'online' && (
                   <>
                   <CheckoutApp
                   tip={customTip || calculateTip()}
                   restaurantId={restaurantId}
                   name={name}
                   phone={phone}
                   cartItems={cart}
                   coupon={calculateDiscount() > 0 ? checkCoupon?.coupon_id : null}
                   address={needDelivery ? currentUserAddress : 'Pickup'}
                   selectedTime={selectedTime ? selectedTime : 'ASAP'}
                   freeItem={freeItem?.Item ? freeItem : null}
                   rewardItem = {rewardItem?.Item ? rewardItem : null}
                   />   
                 {/* </> */}
                  {/* <button  className="black-button  p-3 mt-3" onClick={handlePayInStore} disabled={payinStoreLoading}>
                    {payinStoreLoading ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      'Place Order'
                    )}
                  </button> */}
                  </>
              )}
          
              {paymentOption === 'in-store' && (
                <>
                  <button  className="black-button  p-3 mt-3" onClick={handlePayInStore} disabled={payinStoreLoading}>
                    {payinStoreLoading ? (
                      <span className="spinner-border spinner-border-sm"></span>
                    ) : (
                      'Place Order'
                    )}
                  </button>
                </>
              )}

      {/* <div>
        {error && <p className="text-danger">{error}</p>}
        <div className="row mb-2">
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3">
            <input
              type="text"
              className="form-control"
              id="name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Name"
              style={{ textAlign: 'center' }}
              required
              disabled={activeTab}
              maxLength={20}
            />
          </div>
          <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 mt-3">
            <input
              type="tel"
              className="form-control"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Phone (10 digits, no dashes or spaces)"
              style={{ textAlign: 'center' }}
              required
              disabled={activeTab}
              maxLength={10}
            />
          </div>
          {!activeTab ? (
            <Button variant='primary' className="text-center w-100 mt-4 black-button" onClick={handleContinueCheckout}>
              Continue
            </Button>
          ) : null}
          {activeTab && (
            <>
            <div className='d-flex justify-content-center align-items-center ' onClick={goBack}
                            style={{ fontSize: '20px', cursor: 'pointer', gap: '10px', color: 'black' }}

            >
              <FontAwesomeIcon
                icon={faArrowLeft}
              />
              <p className="text-center mt-3">Back</p>
              </div>
   
            </>
          )}
        </div>
      </div> */}
    </>
  )}
</Modal.Body>

        </>
      </Modal>

 

      <Modal show={timeModal} onHide={() => setTimeModal(false)} centered>
  <Modal.Header closeButton>
    <Modal.Title>Schedule Time</Modal.Title>
  </Modal.Header>
  <Modal.Body>
    <Form>
      <Form.Group>
        <Form.Label>Select a {needSchdule ? 'delivery' : 'pickup'} time</Form.Label>
        <div 
          className="d-flex flex-column" 
          style={{
            maxHeight: '500px',
            overflowY: 'scroll',
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '6px',
            backgroundColor: '#f9f9f9',
          }}
        >
          {timeSlots.length > 0 ? (
            timeSlots.map((slot, index) => (
              <span
                key={index}
                className={`time-slot mb-2 p-2 ${selectedTime === slot ? 'selected-time-slot' : ''}`}
                onClick={() => handleTimeSelect(slot)}
                style={{
                  cursor: 'pointer',
                  border: '1px solid grey',
                  borderRadius: '4px',
                  fontSize: '1.1rem',
                  color: selectedTime === slot ? '#fff' : 'red',
                  backgroundColor: selectedTime === slot ? 'red' : '#fff',
                  transition: 'background-color 0.3s ease, color 0.3s ease',
                }}
              >
                {slot}
              </span>
            ))
          ) : (
            <div>No available time slots</div>
          )}
        </div>
      </Form.Group>
    </Form>
  </Modal.Body>
  <Modal.Footer>
    <button 
    className='w-100 btn-primary'
      onClick={() => setTimeModal(false)}
    >
      Confirm
    </button>
  </Modal.Footer>
</Modal>

    </Container>
    </>
  );
};

export default CheckoutPage;
